module.exports = __webpack_public_path__ + "static/img/cxun.6331f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cxun.png
// module id = 0bVg
// module chunks = 208